import './contact.css';
export const Contact = () => {
  return (
      <div id='contact' className='text-center full-bg'>
        <div className='container'>
          <div className='section-title' data-aos="fade-up">
            <h2>Follow us on Social Media</h2>
              <div className='social'>
                <ul>
                  <li>
                    <a href='/' title="Facebook" rel="noreferrer" target="_blank" className='icon fb-icon'>
                      <img src=".././img/facebook.png" alt="Facebook"/>
                    </a>
                  </li>
                  <li>
                    <a href='/' title="Twitter" rel="noreferrer" target="_blank" className='icon tw-icon'>
                      <img src=".././img/twitter.png" alt="Facebook"/>
                    </a>
                  </li>
                  <li>
                    <a href='/' title="Discord" rel="noreferrer" target="_blank" className='icon dc-icon'>
                      <img src=".././img/discord.png" alt="Facebook"/>
                    </a>
                  </li>
                </ul>
            </div>
            <div className='contact-button-container'>
              <div className='btn btn-custom btn-large'>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M464 64C490.5 64 512 85.49 512 112C512 127.1 504.9 141.3 492.8 150.4L275.2 313.6C263.8 322.1 248.2 322.1 236.8 313.6L19.2 150.4C7.113 141.3 0 127.1 0 112C0 85.49 21.49 64 48 64H464zM217.6 339.2C240.4 356.3 271.6 356.3 294.4 339.2L512 176V384C512 419.3 483.3 448 448 448H64C28.65 448 0 419.3 0 384V176L217.6 339.2z"/></svg><a href="mailto:info@specimenlabs.io" title="Send us an email!" target="_blank" rel="noreferrer">Contact Us!</a>
              </div>
            </div>
          </div>
        </div>
      </div>
  )
}
